// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_spinner__rS0Nz {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.styles_spinner-item__erwwi {
  border-radius: 50%;
  animation: styles_spin__Qhoyz 1s linear infinite;
}
.styles_spinner__rS0Nz.styles_hidden__H95B1 {
  display: none !important;
}
.styles_spinner__rS0Nz .styles_gray__0OjYp {
  border: 8px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
}
.styles_spinner__rS0Nz .styles_blue__1A9NX {
  border: 8px solid var(--color-blue-primary);
  border-top-color: var(--color-blue-secondary);
}
.styles_spinner__rS0Nz .styles_black__76Zr0 {
  border: 8px solid var(--color-gray-900);
  border-top-color: var(--color-gray-300);
}

@keyframes styles_spin__Qhoyz {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(1.1);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/feedback/Spinner/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;AACI;EACI,kBAAA;EACA,gDAAA;AACR;AAEI;EACI,wBAAA;AAAR;AAGI;EACI,0CAAA;EACA,uBAAA;AADR;AAII;EACI,2CAAA;EACA,6CAAA;AAFR;AAKI;EACI,uCAAA;EACA,uCAAA;AAHR;;AASA;EACI;IACI,gCAAA;EANN;EASE;IACI,oCAAA;EAPN;EAWE;IACI,kCAAA;EATN;AACF","sourcesContent":[".spinner {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n\n    &-item {\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n    }\n\n    &.hidden {\n        display: none !important;\n    }\n\n    & .gray {\n        border: 8px solid rgba(255, 255, 255, 0.3);\n        border-top-color: white;\n    }\n\n    & .blue {\n        border: 8px solid var(--color-blue-primary);\n        border-top-color: var(--color-blue-secondary);\n    }\n\n    & .black {\n        border: 8px solid var(--color-gray-900);\n        border-top-color: var(--color-gray-300);\n    }\n}\n\n\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg) scale(1);\n    }\n\n    50% {\n        transform: rotate(180deg) scale(1.1);\n\n    }\n\n    100% {\n        transform: rotate(360deg) scale(1);\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `styles_spinner__rS0Nz`,
	"spinner-item": `styles_spinner-item__erwwi`,
	"spin": `styles_spin__Qhoyz`,
	"hidden": `styles_hidden__H95B1`,
	"gray": `styles_gray__0OjYp`,
	"blue": `styles_blue__1A9NX`,
	"black": `styles_black__76Zr0`
};
export default ___CSS_LOADER_EXPORT___;
